// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form-item__content .el-input-group {\n     vertical-align: middle;\n}\n.el-tag + .el-tag {\n   margin-left: 5px;\n   margin-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
